(() => {
  if (customElements.get('tiya-colour-preview')) return;
  const colourKey = value => {
    const text = String(value || '').toLowerCase();
    if (text.includes('teal')) return 'teal';
    if (text.includes('ash') || text.includes('charcoal')) return 'ash';
    if (text.includes('wine')) return 'wine';
    return '';
  };
  const sizeText = value => {
    const text = String(value || '').toLowerCase();
    if (text.includes('140') || text.includes('single') || text === 'twin') return 'Single \u00b7 140 \u00d7 210 cm';
    if (text.includes('240') || text.includes('king')) return 'King \u00b7 210 \u00d7 240 cm';
    if (text.includes('180') || text.includes('double') || text.includes('full')) return '';
    if (text.includes('queen') || text.includes('210')) return 'Queen \u00b7 210 \u00d7 210 cm';
    return '';
  };
  class TiyaColourPreview extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.addEventListener('click', event => {
        const card = event.target.closest('[data-preview-colour]');
        if (card) this.open(card.dataset.previewColour, card);
        if (event.target.closest('.tcp-close')) this.dialog.close();
        if (event.target === this.dialog) {
          const r = this.dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
        }
      }, { signal });
      this.dialog.addEventListener('close', () => this.restoreFocus(), { signal });
      // Capture colour interactions before the normal asynchronous section fetch.
      // Do not cancel or modify that fetch: Shopify still resolves price and stock.
      const onColour = event => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || !input.matches('.tiya-colours input[type="radio"]')) return;
        const picker = input.closest('variant-picker');
        if (!picker || picker.dataset.productId !== this.dataset.productId || this.dataset.openOnSwatch !== 'true') return;
        const owner = [...document.querySelectorAll('tiya-colour-preview')].find(el => el.dataset.productId === this.dataset.productId && el.dataset.openOnSwatch === 'true');
        if (owner !== this) return;
        const key = colourKey(input.value);
        if (key) this.open(key, input, picker);
      };
      document.addEventListener('click', onColour, { capture: true, signal });
      document.addEventListener('change', onColour, { capture: true, signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    picker() {
      return [...document.querySelectorAll('variant-picker')].find(el => el.dataset.productId === this.dataset.productId);
    }
    open(key, trigger, picker = this.picker()) {
      const names = { teal: 'Teal', ash: 'Ash Grey', wine: 'Wine' };
      if (!names[key]) return;
      const selectedSize = picker?.querySelector('.tiya-options:not(.tiya-colours) input:checked');
      // Prefer the actual option value; the displayed label is a fallback for migrated catalogue labels.
      const size = sizeText(selectedSize?.value) || sizeText(selectedSize?.closest('label')?.textContent);
      for (const figure of this.querySelectorAll('[data-popup-colour]')) figure.hidden = figure.dataset.popupColour !== key;
      this.querySelector('[data-preview-caption]').textContent = names[key] + (size ? ' \u00b7 ' + size : ' \u00b7 Colour preview');
      this.querySelector('h3').textContent = names[key] + ' \u2014 a closer look';
      this.trigger = trigger;
      this.lastKey = key;
      if (!this.dialog.open) this.dialog.showModal();
    }
    restoreFocus() {
      if (this.trigger?.isConnected) { this.trigger.focus({ preventScroll: true }); return; }
      const replacement = [...(this.picker()?.querySelectorAll('.tiya-colours input') || [])].find(input => colourKey(input.value) === this.lastKey);
      (replacement || this.querySelector(`[data-preview-colour="${this.lastKey}"]`))?.focus({ preventScroll: true });
    }
  }
  customElements.define('tiya-colour-preview', TiyaColourPreview);
})();
